import { useGetTosLatest } from 'gen/client';

function isLocalDevelopmentHost(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.location.hostname === 'localhost' || window.location.hostname.endsWith('.localhost');
}

export default function useTermsOfServiceUrl() {
    const shouldFetchLatestTerms = !isLocalDevelopmentHost();
    const { data } = useGetTosLatest({
        swr: {
            enabled: shouldFetchLatestTerms,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    });

    const termsId = data?.id ?? 'default';

    return `${import.meta.env.EXPO_PUBLIC_IMAGE_SERVE_HOST! as string}/tos/${termsId}.pdf`;
}
